<template>
  <div>
    <v-container grid-list-lg fluid>
        <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg4 md12 sm12 pr-6 pl-lg-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuStart"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedStartDateFormatted"
                                label="Từ ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu
                            v-model="menuEnd"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                            >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                v-model="computedEndDateFormatted"
                                label="Đến ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 md12 sm12 pr-6>
                    <v-btn @click="filter_data" color="#f66c16" outlined>Xem</v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12 md12 sm12 xs12>
            <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                    <highcharts :options="chartOptions"></highcharts>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table fixed-header height="750px"   :headers="headers" hide-default-footer :sortable="false" :items="items" :server-items-length="items ? items.length : 0" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{item.ReportDate.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")}}</td>
                            <td class="text-end">{{ item.TotalFeeBuy | currency}}</td>
                            <td class="text-end">{{ item.TotalFeeOther | currency}}</td>
                            <td class="text-end">{{ item.TotalOrderWeight | currency('', 2)}}</td>
                            <td class="text-end">{{ item.TotalOrderVolume | currency('', 3)}}</td>
                            <td class="text-end">{{ item.TotalFeeWeight | currency}}</td>
                            <td class="text-end">{{ item.TotalFeeWeightValue | currency}}</td>
                            <td class="text-end">{{ item.TotalExchangeRevenue | currency}}</td>
                            <td class="text-end">{{ item.TotalBuyRevenue | currency}}</td>
                            <td class="text-end">{{ item.TotalDiscount | currency}}</td>
                            <td class="text-end">{{ item.TotalRecharge | currency}}</td>
                            <td class="text-end">{{ item.TotalRevenue | currency}}</td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="table-summary">
                            <td class="font-weight-bold">TỔNG</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalFeeBuy | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalFeeOther | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalOrderWeight | currency('', 2)}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalOrderVolume | currency('', 3)}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalFeeWeight | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalFeeWeightValue | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalExchangeRevenue | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalBuyRevenue | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalDiscount | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalRecharge | currency}}</td>
                            <td class="font-weight-bold text-end">{{ summary.TotalRevenue | currency}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import {Chart} from 'highcharts-vue';
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        highcharts: Chart 
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            viewName: "bao-cao-tong-hop",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                text: "Ngày",
                value: "ReportDate",
                sortable: false,
                filterable: true,
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Phí dịch vụ",
                value: "TotalFeeBuy",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Phí khác",
                value: "TotalFeeOther",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng cân",
                value: "TotalOrderWeight",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng khối",
                value: "TotalOrderVolume",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Doanh thu vận chuyển",
                value: "TotalFeeWeight",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Lợi nhuận vận chuyển",
                value: "TotalFeeWeightValue",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Lợi nhuận tệ",
                value: "TotalExchangeRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                values: configs.DATA_TYPE["Number"]
                },
                {
                text: "Lợi nhuận mua hàng",
                value: "TotalBuyRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng chiết khấu",
                value: "TotalDiscount",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Hoàn tiền",
                value: "TotalRecharge",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                },
                {
                text: "Tổng lợi nhuận",
                value: "TotalRevenue",
                sortable: false,
                filterable: true,
                align: "end",
                dataType: configs.DATA_TYPE["Number"]
                }                
            ]
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.generalReport.data,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        summary() {
            var ret = {
                'TotalFeeBuy': _.sumBy(this.items, 'TotalFeeBuy'),
                'TotalFeeOther': _.sumBy(this.items, 'TotalFeeOther'),
                'TotalOrderWeight': _.sumBy(this.items, 'TotalOrderWeight'),
                'TotalOrderVolume': _.sumBy(this.items, 'TotalOrderVolume'),
                'TotalFeeWeight': _.sumBy(this.items, 'TotalFeeWeight'),
                'TotalFeeWeightValue': _.sumBy(this.items, 'TotalFeeWeightValue'),
                'TotalExchangeRevenue': _.sumBy(this.items, 'TotalExchangeRevenue'),
                'TotalBuyRevenue': _.sumBy(this.items, 'TotalBuyRevenue'),
                'TotalDiscount': _.sumBy(this.items, 'TotalDiscount'),
                'TotalRevenue': _.sumBy(this.items, 'TotalRevenue'),
                'TotalRecharge': _.sumBy(this.items, 'TotalRecharge'),
            };
            return ret;
        },
        chartOptions() {
            var dataChart =  _.sortBy(this.items,'ReportDate');
            var ret = {
                chart: { type: 'line' },
                title: { text: 'Tổng lợi nhuận' },
                credits: { enabled: false },
                tooltip: {shared: true},
                xAxis: {
                    categories: _.map(dataChart, function(x) {return x.ReportDate.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1")})
                },
                yAxis: {
                    title: {
                        text: 'Tổng tiền (VNĐ)'
                    }
                },
                plotOptions: {
                    line: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: [
                    { 
                        name: 'Phí dịch vụ',
                        data: _.map(dataChart, 'TotalFeeBuy')
                    },
                    { 
                        name: 'Phí khác',
                        data: _.map(dataChart, 'TotalFeeOther')
                    },
                    { 
                        name: 'KG',
                        data: _.map(dataChart, 'TotalOrderWeight')
                    },
                    { 
                        name: 'M3',
                        data: _.map(dataChart, 'TotalOrderVolume')
                    },
                    { 
                        name: 'Phí vận chuyển',
                        data: _.map(dataChart, 'TotalFeeWeight')
                    },
                    { 
                        name: 'Lợi nhuận tệ',
                        data: _.map(dataChart, 'TotalExchangeRevenue')
                    },
                    { 
                        name: 'Lợi nhuận mua hàng',
                        data: _.map(dataChart, 'TotalBuyRevenue')
                    },
                    { 
                        name: 'Chiết khấu',
                        data: _.map(dataChart, 'TotalDiscount')
                    },
                    { 
                        name: 'Hoàn tiền',
                        data: _.map(dataChart, 'TotalRecharge')
                    },
                    { 
                        name: 'Tổng lợi nhuận',
                        data:  _.map(dataChart, 'TotalRevenue')
                    }
                ]
            };

            return ret;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT)
            };
            this.$store.dispatch("report/getGeneralReport", param);
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}
.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>